// src/pages/ConferirDocumento/hooks/useConferirDocumento.js
import { useState } from 'react';
import axios from 'axios';

export const useConferirDocumento = (onSuccess) => {
  const [arquivo, setArquivo] = useState(null);
  const [tipoAnalise, setTipoAnalise] = useState('CONFERENCIA_BASICA');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleFileChange = (file) => {
    if (!file) {
      setArquivo(null);
      return;
    }

    // Validar tamanho (10MB)
    const maxSize = 10 * 1024 * 1024;
    if (file.size > maxSize) {
      setError('Ficheiro muito grande. Máximo: 10MB');
      setArquivo(null);
      return;
    }

    // Validar extensão
    const allowedExtensions = ['pdf', 'docx', 'txt'];
    const ext = file.name.split('.').pop().toLowerCase();
    if (!allowedExtensions.includes(ext)) {
      setError(`Tipo não permitido. Use: ${allowedExtensions.join(', ')}`);
      setArquivo(null);
      return;
    }

    setArquivo(file);
    setError('');
    console.log('📎 Arquivo selecionado:', file.name, `(${(file.size / 1024).toFixed(1)} KB)`);
  };

  const handleRemoverArquivo = () => {
    setArquivo(null);
    setError('');
  };

  const handleEnviar = async () => {
    if (!arquivo) {
      setError('Selecione um ficheiro para conferir');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const formData = new FormData();
      formData.append('file', arquivo);
      formData.append('tipo_analise', tipoAnalise);

      console.log('📤 Enviando documento para conferência...');

      const response = await axios.post(
        '/api/conferir-documento/conferir',
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          timeout: 180000
        }
      );

      if (response.data.success) {
        console.log('✅ Conferência concluída com sucesso');

        // Limpar formulário
        setArquivo(null);
        setTipoAnalise('CONFERENCIA_BASICA');

        // Chamar callback com os dados da conferência criada
        if (onSuccess && response.data.data) {
          onSuccess(response.data.data);
        }
      }

    } catch (err) {
      console.error('❌ Erro ao conferir documento:', err);

      let errorMessage = 'Erro ao conferir documento';

      if (err.response) {
        errorMessage = err.response.data?.message || errorMessage;
      } else if (err.code === 'ECONNABORTED') {
        errorMessage = 'Timeout - A análise está demorando muito. Tente novamente.';
      }

      setError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    arquivo,
    tipoAnalise,
    loading,
    error,
    setTipoAnalise,
    handleFileChange,
    handleRemoverArquivo,
    handleEnviar
  };
};